function initImagePopupModal(sectionId, imageUrls) {
  let modal = document.getElementById('ImagePopupModal-' + sectionId);
  if (!modal || !imageUrls.length) return;

  document.body.appendChild(modal);

  let img = modal.querySelector('.image-popup-modal__img');
  let prevBtn = modal.querySelector('.image-popup-modal__arrow--prev');
  let nextBtn = modal.querySelector('.image-popup-modal__arrow--next');
  let closeBtn = modal.querySelector('.image-popup-modal__close');
  let currentIndex = 0;

  function getIndexByMediaId(mediaId) {
    for (let i = 0; i < imageUrls.length; i++) {
      if (String(imageUrls[i].mediaId) === String(mediaId)) return i;
    }
    return 0;
  }

  function showImage(index) {
    currentIndex = (index + imageUrls.length) % imageUrls.length;
    img.src = imageUrls[currentIndex].src;
    img.alt = imageUrls[currentIndex].alt || '';
    prevBtn.style.display = imageUrls.length > 1 ? '' : 'none';
    nextBtn.style.display = imageUrls.length > 1 ? '' : 'none';
  }

  function openModal(mediaId) {
    let index = getIndexByMediaId(mediaId);
    showImage(index);
    modal.setAttribute('open', '');
    document.body.style.top = '-' + window.scrollY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 50);
  }

  function closeModal() {
    let scrollY = parseInt(document.body.style.top || '0') * -1;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
    modal.removeAttribute('open');
  }

  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeModal();
  });

  prevBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    showImage(currentIndex - 1);
  });

  nextBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    showImage(currentIndex + 1);
  });

  if (closeBtn) closeBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    closeModal();
  });

  document.addEventListener('keyup', function(e) {
    if (!modal.hasAttribute('open')) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
    if (e.key === 'ArrowRight') showImage(currentIndex + 1);
  });

  let mediaGallery = document.getElementById('MediaGallery-' + sectionId);
  if (!mediaGallery) return;

  mediaGallery.querySelectorAll('[data-popup-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopImmediatePropagation();
      let mediaId = btn.getAttribute('data-popup-media-id');
      openModal(mediaId);
    }, true);
  });
}
